import styled from 'styled-components';
import { ErrorMessage } from 'formik';

export const FormControl = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: ${(props) => props.marginBottom || 0};
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  position: relative;

  &.itemDetailsLightbox {
    margin-bottom: 30px;
    textarea {
      height: 100px !important;
      resize: none;
      border: solid 1px ${({ theme: { colors } }) => colors.gray_4};
      padding: 15px;
      &.error {
        border: solid 1px ${({ theme: { colors } }) => colors.red_1};
      }
    }
  }

  &.itemAbortModal {
    textarea {
      height: 100px !important;
      resize: none;
      border: solid 1px ${({ theme: { colors } }) => colors.gray_4};
      padding: 15px;
      &.error {
        border: solid 1px ${({ theme: { colors } }) => colors.red_1};
      }
    }
  }

  &.assignBuyerModal {
    justify-content: center;
    gap: 30px;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
  }

  label {
    &.labelSelect {
      margin-bottom: 6px;
      display: inline-block;
      font-family: Lato;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #333333;
    }
    img {
      margin-left: 7px;
    }
  }

  .tooltip-container {
    width: 185px;
  }

  &.itemMaxValue.currency {
    position: relative;
    &:before {
      content: 'R$';
      height: 23px;
      width: 25px;
      bottom: 10px;
      left: 4px;
      color: ${({ theme: { colors } }) => colors.black_1};
      display: block;
      position: absolute;
      font-size: ${({ theme: { fontSize } }) => fontSize.big};
    }
    input {
      padding-left: 25px;
    }
  }

  &.itemCategory {
    label {
      white-space: nowrap;
      margin-bottom: 14px;
    }
  }

  &.itemSuggestedStore {
    flex-grow: 1;
    label {
      white-space: nowrap;
    }
    @media (max-width: 905px) {
      max-width: unset;
      width: 285px;
    }
  }

  &.itemMaxValue {
    label {
      white-space: nowrap;
    }
    @media (max-width: 1013px) {
      max-width: unset;
      flex-grow: 1;
    }
  }

  &.itemObservations {
    @media (max-width: 1013px) {
      max-width: unset;
      flex-grow: 1;
    }
  }

  &.outlinedInput {
    label {
      margin-bottom: 6px;
      font-family: Lato;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #333333;
    }
    input {
      background: #ffffff;
      border: 1px solid #cccccc;
      box-sizing: border-box;
      border-radius: 10px;
      padding: 8px 10px;
      height: 40px;
    }
  }

  &.outlinedSelect {
    span {
      color: red;
      margin-top: 5px;
    }
    .formikSelect {
      &__control {
        border-radius: 4px;
        height: 40px;
      }
      &__placeholder {
        color: ${({ theme: { colors } }) => colors.gray_2} !important;
      }
      &__single-value {
        color: ${({ theme: { colors } }) => colors.black_3};
        font-style: normal;
      }
      &__value-container {
        padding: 0 10px !important;
      }
    }
  }

  .formikSelect {
    &__control {
      width: 100%;
      align-items: center;
      background-color: ${({ theme: { colors } }) => colors.white_1};
      box-shadow: none;
      cursor: default;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      outline: 0 !important;
      position: relative;
      transition: all 100ms;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #cccccc;
      border-radius: 10px;
      height: 40px;

      /* &--is-focused {
        border-color: #333333;
        box-shadow: none;
      } */
    }

    &__value-container {
      padding: 0px !important;
      display: flex;
      justify-content: flex-start;
    }

    &__single-value {
      max-width: 100%;
      width: 100%;
      text-align: left;
      color: ${({ theme: { colors } }) => colors.black_1};
      font-size: ${({ theme: { fontSize } }) => fontSize.big} !important;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }

    &__option {
      &--is-selected {
        background-color: #2328eb !important;
        color: #ffff !important;
      }
      &--is-focused {
        background-color: #999999 !important;
        color: #ffff !important;
      }
    }

    &__indicator-separator {
      display: none;
    }
    &__placeholder {
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 14px;
      color: #999999;
    }

    &__value-container {
      padding: 0px !important;
    }

    &__input {
      font-size: ${({ theme: { fontSize } }) => fontSize.middlest};
      font-weight: normal;
      font-style: normal;
      letter-spacing: normal;
      color: ${({ theme: { colors } }) => colors.black_1};
    }
  }

  label {
    font-size: ${({ theme: { fontSize } }) => fontSize.smallest};
    font-style: normal;
    letter-spacing: 0.3px;
    margin-bottom: 16px;
    font-weight: 700;
    line-height: 15px;
    color: ${({ theme: { colors } }) => colors.black_4};

    &.newStyle {
      font-size: ${({ theme: { fontSize } }) => fontSize.middle};
      font-style: normal;
      font-weight: 700;
      line-height: 15px;
      text-transform: capitalize;
      color: ${({ theme: { colors } }) => colors.black_1};
      letter-spacing: 0.3px;
    }

    &.disabled {
      color: ${({ theme: { colors } }) => colors.gray_2};
    }

    span {
      font-size: ${({ theme: { fontSize } }) => fontSize.smallest};
      font-style: normal;
      font-weight: 400;
      line-height: 15px;

      &.newStyle {
        font-style: normal;
        font-size: ${({ theme: { fontSize } }) => fontSize.medium_small};
        font-weight: 400;
        line-height: 15px;
        letter-spacing: 0px;
        text-align: left;
      }
    }
  }

  .overrider-border {
    .formikSelect {
      &__control {
        border-bottom: solid 1px red !important;
      }
    }
  }

  textarea,
  select,
  input {
    color: ${({ theme: { colors } }) => colors.black_1};
    font-size: ${({ theme: { fontSize } }) => fontSize.big} !important;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    border: none;
    background: ${({ theme: { colors } }) => colors.white_1};
    border-bottom: 1px solid ${({ theme: { colors } }) => colors.gray_9};

    &.error {
      border-bottom: 1px solid red;
    }
    &::placeholder {
      font-size: ${({ theme: { fontSize } }) => fontSize.middlest};
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      color: ${({ theme: { colors } }) => colors.gray_2};
    }
  }

  select,
  input {
    padding-bottom: 10px;
  }

  option {
    color: ${({ theme: { colors } }) => colors.black_1};
    font-size: ${({ theme: { fontSize } }) => fontSize.middlest};
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    @media (max-width: 768px) {
      width: 100%;
      margin-top: 0;
      margin-bottom: 0;
      flex: ${({ maxWidth }) => (maxWidth ? `1 0 ${maxWidth}` : 1)};
    }
  }
`;

export const Errors = styled(ErrorMessage)`
  color: red;
`;
